import React, { useState, useContext, useCallback, useEffect } from 'react';
import useMount from 'ggApp/shared/hooks/useMount';
import { PureTranslator } from 'ggApp/modules/translator/components';
import {
    CHECKOUT_FLOW_NAMES,
    CHECKOUT_STEP_NAMES as STEP_NAMES,
} from 'ggApp/modules/newCheckout/constants';
import { AddressComponent } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/AddressComponent';
import { AddressList } from 'ggApp/modules/newCheckout/components/CheckoutStep/steps/AddressList';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import { updateOrderStepState } from 'ggApp/shared/context/Order/services/tracking';

import { Shipping, Title, SubTitle } from './styles';

export const ShippingAddress = ({ stepData, flowName }) => {
    const { current, orderNumber, send, userAddresses, orderMode } = useContext(OrderContext);
    const [addressInForm, setAddressInForm] = useState(null);
    const [hasAddresses, setHasAddresses] = useState(true);
    const [shouldShowList, setShouldShowList] = useState(true);

    useEffect(() => {
        if (current.matches('shippingAddress')) {
            setShouldShowList(!current.matches('shippingAddress.form'));
        }
    }, [current]);

    useMount(() => {
        if (current.matches('shippingAddress')) {
            updateOrderStepState({
                orderMode,
                orderNumber,
                currentStep: STEP_NAMES.SHIPPING_ADDRESS,
            });
        }

        if (!userAddresses || !userAddresses.length) {
            send('EDIT');
            setShouldShowList(false);
        }
    }, [send, current, userAddresses]);

    const onSubmitClick = useCallback(
        (formAddress) => {
            send('SUBMIT', {
                orderNumber,
                address: formAddress,
            });
        },
        [send, orderNumber],
    );

    return (
        <Shipping data-testid="shipping-address">
            <Title>
                <PureTranslator tk={stepData.title} />
            </Title>

            {flowName === CHECKOUT_FLOW_NAMES.CHECKOUT_NO_HOME_ADDRESS && (
                <SubTitle>
                    <PureTranslator tk={stepData.subTitle} />
                </SubTitle>
            )}

            {shouldShowList ? (
                <AddressList
                    stepName={STEP_NAMES.SHIPPING_ADDRESS}
                    addTK={stepData.addBtn}
                    setHasAddresses={setHasAddresses}
                    onSubmitClick={onSubmitClick}
                    flowName={flowName}
                    setAddressInForm={setAddressInForm}
                    current={current}
                    send={send}
                />
            ) : (
                <AddressComponent
                    send={send}
                    current={current}
                    address={addressInForm}
                    stepData={stepData}
                    shouldShowBackBtn={hasAddresses}
                    shouldShowHint={flowName === CHECKOUT_FLOW_NAMES.CHECKOUT_WITH_HOME_ADDRESS}
                />
            )}
        </Shipping>
    );
};
